export const isConnected = () => !!window.freighter;
